import { Button, DialogActions, DialogContent } from '@mui/material'
import { FC, useCallback, useState } from 'react'

import { useUpdateCannedJobDate } from '../../../hooks'
import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetAllInventoryPartsQuery } from '../../../redux/api'
import {
  CannedJobCustomPartEntry,
  CannedJobInventoryPartEntry,
  CannedJobToInventoryProductEntry,
  InventoryPartEntry
} from '../../../sdk'
import { CONTENT_HEIGHT } from '../../Estimates/useLookupPartsDialog/LookupPartsWindow'
import { SearchInventoryForm } from '../../Estimates/useLookupPartsDialog/SearchInventoryForm'
import { CannedJobInventoryForm } from './CannedJobInventoryForm'
import { CannedJobProductForm } from './CannedJobProductForm'
type Props = {
  cancelCallback: () => void
  existingEntry: CannedJobInventoryPartEntry | undefined
  existingCannedJobToProductEntry: CannedJobToInventoryProductEntry | undefined
  inventoryEntry: InventoryPartEntry | undefined
  productEntry: CannedJobCustomPartEntry | undefined
  cannedJobId: string
}

export const SearchInventoryFormWrapperForCannedJob: FC<Props> = ({
  cancelCallback,
  existingEntry,
  existingCannedJobToProductEntry,
  inventoryEntry,
  productEntry,
  cannedJobId
}) => {
  const [selected, setSelected] = useState<InventoryPartEntry | undefined>(
    inventoryEntry
  )
  const [selectedProduct, setSelectedProduct] = useState<
    CannedJobCustomPartEntry | undefined
  >(productEntry)
  const [searchTerm, setSearchTerm] = useState('')
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { data: shopInventory } = useGetAllInventoryPartsQuery(
    {
      authorization: accessToken,
      shop: shopId,
      stockedOnly: false,
      partId: [selected?.id!]
    },
    { skip: !selected?.id }
  )
  const { updateDate } = useUpdateCannedJobDate()
  const submitCallback = useCallback(() => {
    updateDate()
    cancelCallback()
  }, [cancelCallback, updateDate])
  return (
    <>
      <DialogContent
        sx={{
          height: CONTENT_HEIGHT,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
        {selected && shopInventory && (
          <CannedJobInventoryForm
            {...{
              existingEntry,
              cannedJobId,
              selected,
              shopInventory,
              submitCallback
            }}
          />
        )}
        {selectedProduct && (
          <CannedJobProductForm
            {...{
              existingCannedJobToProductEntry,
              cannedJobId,
              selectedProduct,
              submitCallback
            }}
          />
        )}
        {!selected && !selectedProduct && (
          <SearchInventoryForm
            {...{ selected, selectedProduct, searchTerm, setSearchTerm }}
            setSelected={(selected: InventoryPartEntry | undefined) => {
              setSelected(selected)
              setSelectedProduct(undefined)
            }}
            setSelectedProduct={(
              selected: CannedJobCustomPartEntry | undefined
            ) => {
              setSelected(undefined)
              setSelectedProduct(selected)
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={cancelCallback}>
          Cancel
        </Button>
        <Button
          variant="outlined"
          form={'searchInventoryForm'}
          type={'submit'}
          disabled={!selected && !selectedProduct}>
          Save
        </Button>
      </DialogActions>
    </>
  )
}
